var _path, _path2, _path3, _g, _path4, _path5, _path6, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_425_45)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50 100C77.6142 100 100 77.6142 100 50C100 22.3858 77.6142 0 50 0C22.3858 0 0 22.3858 0 50C0 77.6142 22.3858 100 50 100Z",
    fill: "url(#paint0_radial_425_45)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2778 49.9864C13.2778 27.0837 27.7361 7.55588 48.0278 0.0419922C21.3333 1.08366 0 23.042 0 50.0003C0 76.9864 21.375 98.9726 48.1111 99.9587C27.7917 92.4587 13.2778 72.917 13.2778 49.9864Z",
    fill: "url(#paint1_radial_425_45)"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_425_45",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 49,
    height: 100
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.2778 49.9864C13.2778 27.0837 27.7361 7.55588 48.0278 0.0419922C21.3333 1.08366 0 23.042 0 50.0003C0 76.9864 21.375 98.9726 48.1111 99.9587C27.7917 92.4587 13.2778 72.917 13.2778 49.9864Z",
    fill: "url(#paint2_radial_425_45)"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_425_45)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.2778 49.9864C13.2778 27.0837 27.7361 7.55588 48.0278 0.0419922C21.3333 1.08366 0 23.042 0 50.0003C0 76.9864 21.375 98.9726 48.1111 99.9587C27.7917 92.4587 13.2778 72.917 13.2778 49.9864Z",
    fill: "url(#paint3_radial_425_45)"
  }))), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M49.1526 45.2358C52.472 37.0552 46.2637 34.833 42.222 34.833H28.8331C29.9442 35.5969 29.7637 36.6108 29.5415 37.2358L21.7359 62.1663C21.4303 63.1525 20.2637 64.1941 19.6387 64.3469H30.472C29.8748 64.2358 29.0276 63.3886 29.3331 62.2358L32.1665 53.2219C32.1803 53.2219 45.2081 54.9858 49.1526 45.2358ZM38.6248 37.1247C40.0415 37.1247 43.972 37.3191 41.4303 44.7497C38.7776 52.5552 32.8887 50.9441 32.8887 50.9441L37.222 37.1247H38.6248Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M57.8194 64.3613H65.1111C62.7778 63.6113 59.3333 61.4029 57.9583 59.8335C59.0694 58.6252 60.4444 57.0974 60.6944 54.0001H56.9167C56.9167 54.0001 57.6389 54.4168 57.6389 55.3057C57.6389 56.1252 57.3056 57.264 56.6667 58.0557C55.5556 56.4168 54.375 54.5418 53.9583 51.7918C55.4444 51.0557 57.5278 50.2502 59.1806 48.8057C60.75 47.4307 61.1111 46.1252 61.1389 45.2779V45.1668C61.1389 44.2779 60.7917 43.4446 60.1528 42.8196C59.0556 41.7363 57.3333 41.2918 55.5139 41.6252C54.0556 41.9029 52.8194 42.6807 52.1944 43.2501C50 45.3196 49.7222 48.7224 49.7222 50.264C49.7222 50.639 49.7361 50.9168 49.75 51.0835C49.625 51.139 49.4028 51.2224 49.4028 51.2224C47.7917 51.8196 43.5 52.9585 41.9722 56.4863C41.7778 56.9307 41.5 57.9029 41.5 59.0279C41.5 60.0002 41.7083 61.0835 42.3333 62.0696C43.4167 63.764 45.25 64.8335 48.1944 64.7779C51.3889 64.7224 54.5417 62.5418 55.0972 62.139C55.6389 62.6529 57.0694 64.0002 57.8194 64.3613ZM57.8194 44.639C57.4444 47.014 54.3611 49.4168 53.6111 49.7363C53.4722 48.4029 53.5417 46.2918 54.6528 44.5696C55.3889 43.4307 56.375 42.9307 57.1667 43.2085C57.8056 43.4307 57.875 44.014 57.8194 44.639ZM53.5417 60.5279C53.1111 60.7918 51.4167 61.6529 49.8333 61.8057C48.3611 61.9446 45.9167 61.3752 45.9306 58.4307C45.9306 55.9168 48.6667 54.0696 50.1528 53.4307C50.75 55.8613 52.0972 58.6113 53.5417 60.5279Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M79.9723 37.1528C84.3057 36.1111 87.8751 39.5 88.1946 39.7361L89.4307 35.8055C87.7223 35.2916 75.2918 31.0833 66.5001 41.1111C61.0973 47.2778 59.7779 59.9166 66.6251 63.3055C73.9585 66.9305 82.0557 62.75 82.6529 62.4583L86.0001 51.7916C86.3612 50.5 87.1807 49.6666 88.6251 49.125H76.9862C78.6807 49.8333 78.5557 51.1111 78.4307 51.6389L75.0834 62.3055C74.639 62.3889 65.2779 64.7222 70.514 48.3472C71.6668 44.8333 74.8196 38.3889 79.9723 37.1528Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_425_45",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.2079 19.4597) scale(93.3768)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00A1DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.13,
    stopColor: "#0092D7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.37,
    stopColor: "#006CC1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#003DA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#043799"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.93,
    stopColor: "#102777"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#152169"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_425_45",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.4101 7.71009) scale(154.825 154.825)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.03,
    stopColor: "#FBFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09,
    stopColor: "#BAE7F9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.14,
    stopColor: "#87D5F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.19,
    stopColor: "#63C9F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.23,
    stopColor: "#4CC1EF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26,
    stopColor: "#44BEEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.28,
    stopColor: "#37B8EB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#19ACE5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#07A4E0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#00A1DF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79,
    stopColor: "#0045AB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#003DA6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.96,
    stopColor: "#0059B6"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_425_45",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(41.9429 48.4766) rotate(-88.2324) scale(53.8518 54.8004)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.35,
    stopColor: "#FDFDFD"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.45,
    stopColor: "#F6F6F6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.51,
    stopColor: "#EAEAEA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.57,
    stopColor: "#D9D9D9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.62,
    stopColor: "#C3C3C3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.66,
    stopColor: "#A7A7A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7,
    stopColor: "#868686"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.73,
    stopColor: "#606060"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.77,
    stopColor: "#353535"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_425_45",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(38.897 40.2445) scale(62.9069 62.9069)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.32,
    stopColor: "#44BEEE",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.48,
    stopColor: "#2B99D9",
    stopOpacity: 0.27
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.67,
    stopColor: "#1476C6",
    stopOpacity: 0.58
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.82,
    stopColor: "#0561BA",
    stopOpacity: 0.84
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.92,
    stopColor: "#0059B6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_425_45"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 100,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.ab9fac79315fb2bd78ef9ca7172c004f.svg";
export { ForwardRef as ReactComponent };